export default __webpack_public_path__ + "static/media/imss.91d362fb.png";